import { h, FunctionComponent } from 'preact';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import CurrencyText from '~src/domains/common/components/CurrencyText';
import InfoGroup from '~src/domains/common/components/InfoGroup';
import {
  customerInfoSelector,
  loanOfferSelectionSelector,
  loanOffersSelector,
  localeSelector,
} from '~src/domains/common/state/commonSelectors';
import * as infoGroupsStyles from '~src/styles/domains/common/components/infoGroup.module.scss';
import { applyMask, formatCustomerNames } from '~src/utils/helpers';
import StartFromPricing from './StartFromPricing';
import StartReservations from './StartReservations';

type StartInfoProps = {
  showNameInfoGroup: boolean;
};

const StartInfo: FunctionComponent<StartInfoProps> = ({
  showNameInfoGroup,
}) => {
  const { t } = useTranslation();

  const loanOfferSelection = useSelector(loanOfferSelectionSelector);
  const loanOffers = useSelector(loanOffersSelector);
  const offer = loanOffers.find(offer => offer.offer_id === loanOfferSelection);
  const customerInfo = useSelector(customerInfoSelector);
  const { email, phone } = customerInfo;
  const { firstName, lastName } = formatCustomerNames({
    firstName: customerInfo.first_name,
    lastName: customerInfo.last_name,
  });
  const formattedPhoneNumber = phone && applyMask(phone, '999-999-9999');
  const locale = useSelector(localeSelector);

  return (
    <div>
      {showNameInfoGroup && (
        <InfoGroup
          header={t('start:read-only-labels.name')}
          value={`${firstName} ${lastName}`}
        />
      )}
      {formattedPhoneNumber && (
        <InfoGroup
          header={t('start:read-only-labels.phone-number')}
          value={formattedPhoneNumber}
        />
      )}
      {email && (
        <InfoGroup header={t('start:read-only-labels.email')} value={email} />
      )}
      <StartReservations />
      {offer && (
        <>
          <InfoGroup
            header={t('start:read-only-labels.purchase-cost')}
            value={
              <CurrencyText
                value={offer.order_amount}
                locale={locale}
                superscript={false}
                className={infoGroupsStyles['info-group-value']}
              />
            }
          />
          <StartFromPricing offer={offer} locale={locale} />
        </>
      )}
    </div>
  );
};

export default StartInfo;
